module.exports = __webpack_public_path__ + "static/media/ard.a44d1df1.png";